<script>
    import UserIcon from './UserIcon.svelte';

    let user = "";

    let visible = false;
    let w, h;
    let fixedPos = "";

    let dialogElement;
    
    export function show(pos, email) {
        user = email;
        if (pos) {
            let deltaX = innerWidth - (pos.x + w);
            let deltaY = innerHeight - (pos.y + h);
            fixedPos = `left: ${pos.x + (deltaX < 0 ? deltaX : 0)}px; top: ${pos.y + (deltaY < 0 ? deltaY : 0)}px;`;
        }
        visible = true;
        setTimeout(() => dialogElement.focus(), 100);
    }

    export function hide() {
        visible = false;
    }

    export function isVisible() {
        return visible;
    }
</script>

<!-- tabindex of this element is required for it to give the blur (lost focus) event -->
<div bind:this={dialogElement} on:blur class="container" class:visible style="{fixedPos}" bind:clientWidth={w} bind:clientHeight={h} tabindex="-1">
    <UserIcon style="grid-row: 1 / span 2; justify-self: center; align-self: center; margin: 20px 10px;" size=48 iconSize="2.6x" />
    <span class="label">Logged in as</span>
    <span class="email">{user}</span>
    <div class="line"></div>
    <a class="logout" href="/.auth/logout" on:mousedown|preventDefault>Log out</a>
</div>

<style>
    .container {
        display: none;
        border-radius: 3px;
        grid-template-columns: 1fr 2fr 1fr;
        grid-template-rows: 1fr 1fr 40px;
        position: absolute;
        background-color: #fff;
        box-shadow: 1px 1px 8px 0px #00000044;
        z-index: 1000;
    }

    .container:focus {
        outline: 0 !important;
    }

    .visible {
        display: grid;
    }

    .label {
        color: #888;
        grid-row: 1;
        grid-column: 2;
        align-self: end;
    }

    .email {
        color: #111;
        grid-row: 2;
        grid-column: 2;
        align-self: start;
    }

    .line{
        position: absolute;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid #dadada;
        grid-row: 3;
        grid-column: 1 / span 3;
        align-self: start;
    }
    
    .logout {
        grid-row: 3;
        grid-column: 1 / span 3;
        justify-self: end;
        align-self: center;
        margin: 5px 10px;
    }

    * {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    }
</style>